// extracted by mini-css-extract-plugin
export default {"container":"PickupStoreError_container__x5YlS","content":"PickupStoreError_content__t3-Aa"};